const handleDropDown = () => {
	const input = document.getElementById('SortBy');
	const dropdown = document.getElementById('sort__dropdown')
	const options = document.querySelectorAll('.sort__dropdown-option')

	const labelMobile = document.querySelector('.SortBy__label--mobile')
	const dropdownMobile = document.getElementById('sort__dropdown--mobile')
	const optionsMobile = document.querySelectorAll('.sort__dropdown--mobile-option')
	const svg = dropdownMobile.parentNode.parentNode.querySelector('svg')

	const preventDefault = e => e.preventDefault()
	const toggleDropdown = e => {
		preventDefault(e)
		e.stopPropagation()
		dropdown.classList.toggle('open')
		svg.classList.toggle('open')
	}
	const toggleDropdownMobile = e => {
		preventDefault(e)
		e.stopPropagation()
		dropdownMobile.classList.toggle('open')
		svg.classList.toggle('open')
	}

	input.addEventListener('click', toggleDropdown)
	labelMobile.addEventListener('click', toggleDropdownMobile)

	options.forEach(option => {
		const handleSelect = () => {
			const value = option.getAttribute('value')
			location.search = `sort_by=${value}`
			dropdown.classList.remove('open')
		}

		option.addEventListener('click', handleSelect)

		window.onunload = function() {
			option.removeEventListener('click', handleSelect)
		}
	})

	optionsMobile.forEach(option => {
		const handleSelect = () => {
			const value = option.getAttribute('value')
			location.search = `sort_by=${value}`
			dropdownMobile.classList.remove('open')
			svg.classList.remove('open')
		}

		option.addEventListener('click', handleSelect)

		window.onunload = function() {
			option.removeEventListener('click', handleSelect)
		}
	})

	window.onunload = function() {
		input.removeEventListener('click', toggleDropdown)
		labelMobile.removeEventListener('click', toggleDropdownMobile)
	}
}

handleDropDown()

window.handleDropDown = handleDropDown;
